import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, take, timeout } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StudentService {
  constructor(private http: HttpClient) {}

  getStudentByNationalId(nationalId: string, programsCodes: string): Observable<any> {
    return this.http.get<any>(
      `${environment.api}/vwstudents?$select=vwStudentId,nationalid,name,photo,birthdate,unitCode,phones,emails,programCode&$count=true&$top=1&$filter=ProgramCode in (${programsCodes}) and nationalId eq '${nationalId}'&$orderby=endDate desc`
    );
  }

  searchStudent(searchInput: string, programsCodes: string): Observable<any> {
    return this.http.get<any>(
      `${environment.api}/vwstudents?$select=vwStudentId,nationalid,name,photo,birthdate,unitCode,phones,emails,programCode&$filter=ProgramCode in (${programsCodes}) and contains(name, '${searchInput}') or nationalId eq '${searchInput}'&$orderby=endDate desc`
    );
  }

  searchStudentByNationalId(nationalId: string): Observable<any> {
    return this.http.get<any>(
      `${environment.api}/vwstudents?$select=vwStudentId,nationalid,name,photo,birthdate,unitCode,phones,emails,programCode,category,endDate,startDate&$count=true&$top=1&$filter=nationalId eq '${nationalId}'&$orderby=endDate desc`
    );
  }

  getClientela(nationalId: string): Observable<any> {
    return this.http.get<any>(
      `${environment.api}/clientela?$select=nationalid,name,photo,birthdate,unitCode,category,dueDate&$filter=nationalId in (${nationalId})&$orderby=dueDate DESC`
    );
  }

  getStudentsByNationalIds(nationalIds: string): Observable<any> {
    return this.http.get<any>(
      `${environment.api}/vwstudents?$select=vwStudentId,nationalid,name,photo,programCode&$count=true&$filter=nationalId in (${nationalIds})`
    );
  }

  getStudent(nationalId: string): Observable<any> {
    return this.http.get<any>(
      `${environment.api}/Students?$select=id,nationalId,goals,restrictions,fingerprint,active,KeyboardPassword,lockKeyboard&$top=1&$filter=nationalId eq '${nationalId}'`
    );
  }

  getNewStudents(
    unitCode: string,
    month: number,
    year: number,
    programCode: string,
    startDate: string,
    endDate: string
  ): Observable<any> {
    return this.http
      .get<any>(
        `${environment.api}/vwstudents?$select=nationalid,name,photo,category&$count=true&$filter=startdate le ${startDate} and enddate ge ${endDate} and unitcode eq '${unitCode}' and ProgramCode  in (${programCode}) and month(enrollmentDate) eq ${month} and year(enrollmentDate) eq ${year}`
      )
      .pipe(
        map((data) => {
          let students = {
            count: data['@odata.count'],
            students: data['value']
          };
          return students;
        })
      );
  }

  getAllStudents(unitCode: string, programCode: string, startDate: string, endDate: string): Observable<any> {
    return this.http.get<any>(
      `${environment.api}/vwstudents?$select=nationalid,name,photo,category&$filter=startdate ge ${startDate} and enddate le ${endDate} and unitcode eq '${unitCode}' and ProgramCode  in (${programCode}) and enrollmentStatus eq '0'`
    );
  }

  getStudentsByDay(unitCode, startDate: string, endDate: string) {
    return this.http.get<any>(
      `${environment.api}/events?$select=nationalId&$count=true&$filter=createdAt ge ${startDate} and createdAt lt ${endDate} and unitcode eq '${unitCode}'`
    );
  }

  /**
   * Função que faz a chamada para a fingerprint e retorna o fingerprint e o base64
   * @param nationalId CPF do aluno
   * @param expireTime Tempo limite de expiração da requisição em segundos
   * @returns Objeto com a fingerprint
   */
  getFingerPrints(nationalId: string, expireTime: number, uriFingerReader: string): Observable<any> {
    return this.http.get<any>(`${uriFingerReader}/capture/${nationalId}`).pipe(take(1), timeout(expireTime * 1000));
  }

  postStudent(studentData: any): Observable<any> {
    return this.http.post<any>(`${environment.api}/Students`, studentData).pipe(take(1));
  }
  updateStudent(data: any): Observable<any> {
    return this.http.put<any>(`${environment.api}/Students/${data.id}`, data).pipe(take(1));
  }
}
